
import ApiList from '@/views/center/openApiList/apiList'

export default {
  components: {
    ApiList
  },
  data () {
    return {}
  },
  methods: {
    copyerr () {
      this.$message.error({
        message: '复制失败',
        duration: 1000
      })
    },
    copyon () {
      this.$message.success({
        message: '复制成功',
        duration: 1000
      })
    },
    resetToken () {
      this.$confirm('是否确认要重置Token?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data } = await this.$http.post('/users/tokenreset')
        if (data.status == 'success') {
          this.$store.commit('setOther', {
            name: 'token',
            value: data.token
          })//密钥
          localStorage.setItem('key',data.token)
          this.$message({
            type: 'success',
            message: '重置成功!'
          })
        } else {
          this.$message({
            type: 'error',
            message: data.msg
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置'
        })
      })
    }
  }
}
